export type NavItem = {
  key: string;
  path: string;
  labelKey: string;
};

/** Preserve the waitlist-era header exactly while production remains gated. */
const WAITLIST_NAV_ITEMS: readonly NavItem[] = [
  { key: "home", path: "/", labelKey: "nav.home" },
] as const;

const LAUNCHED_NAV_ITEMS: readonly NavItem[] = [
  { key: "home", path: "/", labelKey: "nav.home" },
  { key: "product", path: "/product", labelKey: "nav.product" },
  { key: "pricing", path: "/pricing", labelKey: "nav.pricing" },
  { key: "docs", path: "/docs", labelKey: "nav.docs" },
  { key: "download", path: "/download", labelKey: "nav.download" },
] as const;

export function navItems(launched: boolean, showDesktopDownload = true): readonly NavItem[] {
  if (!launched) return WAITLIST_NAV_ITEMS;
  return showDesktopDownload
    ? LAUNCHED_NAV_ITEMS
    : LAUNCHED_NAV_ITEMS.filter((item) => item.key !== "download");
}

export function localePrefix(_pathname: string): string {
  return "";
}

export function localizedPath(_pathname: string, path: string): string {
  return path;
}

export function isNavActive(pathname: string, itemPath: string): boolean {
  if (itemPath === "/") {
    return pathname === "/";
  }
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}

/**
 * Append the current query string to an internal path so navigation doesn't
 * drop UTM / referral params. Preserves any hash in `to`.
 */
export function preserveSearch(to: string, search: string): string {
  if (!search || search === "?") return to;
  const url = new URL(to, "http://localhost");
  const params = new URLSearchParams(search);
  params.forEach((value, key) => {
    // Legacy referral-status URLs placed an email/code in `lookup`. Referral
    // consumes that value once and moves it into router state; never copy it
    // onto another visible URL where autocapture, replay, logs, or screenshots
    // could retain it.
    if (key === "lookup") return;
    if (!url.searchParams.has(key)) {
      url.searchParams.append(key, value);
    }
  });
  return `${url.pathname}${url.search}${url.hash}`;
}
